<template>
  <div>
    <template v-if="status=='edit'">
      <workerEdit v-if="type == 'worker'"></workerEdit>
      <retireEdit v-if="type == 'retire'"></retireEdit>
      <leaverEdit v-if="type == 'leaver'"></leaverEdit>
    </template>
    <template v-if="status=='see'">
      <workerSee v-if="type == 'worker'"></workerSee>
      <retireSee v-if="type == 'retire'"></retireSee>
      <leaverSee v-if="type == 'leaver'"></leaverSee>
    </template>
  </div>
</template>
<script>
  import workerEdit from './editList/workerEdit'
  import retireEdit from './editList/retireEdit'
  import leaverEdit from './editList/leaverEdit'
  import workerSee from './seeList/workerSee'
  import retireSee from './seeList/retireSee'
  import leaverSee from './seeList/leaverSee'
  export default{
    name:'workerInfo',
    data () {
      return{
        status:this.$route.params.status,
        type:this.$route.params.type
      }
    },
    components:{
      'workerEdit':workerEdit,
      'retireEdit':retireEdit,
      'leaverEdit':leaverEdit,
      'workerSee':workerSee,
      'retireSee':retireSee,
      'leaverSee':leaverSee
    },
    methods:{

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/workerInfo.vue